import AppShell from '../components/AppShell';
import OnboardingFlow from '../components/OnboardingFlow';

export default function OnboardingPage() {
  return (
    <AppShell showBack title="Set Up Your Quiz">
      <div className="max-w-lg mx-auto px-4 py-8">
        <div className="onboarding-surface p-6 sm:p-8 rounded-[2.5rem] text-white relative overflow-hidden">
          <div className="relative z-10">
            <OnboardingFlow mode="start" />
          </div>
        </div>
      </div>
    </AppShell>
  );
}
